import { useOpenCopilot } from 'copilot-toolkit/hooks/useOpenCopilot';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { useAppContext } from '../../context/AppContext';
import { getFullMarketplaceUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
export function HeroButton({
  buttonText,
  buttonUrl,
  onClick,
  openCopilot = false,
  size,
  use = 'secondary'
}) {
  const openCopilotFn = useOpenCopilot();
  const appContext = useAppContext();
  const handleClick = () => {
    if (openCopilot) {
      openCopilotFn();
    }
    onClick === null || onClick === void 0 || onClick();
  };
  if (!buttonUrl) {
    return /*#__PURE__*/_jsx(Button, {
      onClick: handleClick,
      size: size,
      use: use,
      children: buttonText
    });
  }

  // If this is a copilot button AND user is authenticated, open copilot instead of URL
  if (openCopilot && appContext !== 'public') {
    return /*#__PURE__*/_jsx(Button, {
      onClick: handleClick,
      size: size,
      use: use,
      children: buttonText
    });
  }
  const ecosystemUrlPattern = /^https:\/\/ecosystem\.hubspot(qa)?\.com\/marketplace(.*)$/;
  const match = buttonUrl.match(ecosystemUrlPattern);
  if (match) {
    const routerPath = match[2] || '/';

    // Check for UTM parameters specifically
    const urlParams = new URLSearchParams(buttonUrl);
    const hasUtmParams = Array.from(urlParams.keys()).some(param => param.startsWith('utm'));
    if (hasUtmParams) {
      return /*#__PURE__*/_jsx(Button, {
        href: getFullMarketplaceUrl(appContext, routerPath),
        onClick: onClick,
        size: size,
        use: use,
        children: buttonText
      });
    }
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "stretch",
      blockSize: "100%",
      children: /*#__PURE__*/_jsx(UIRouterButton, {
        disabled: false,
        external: false,
        onClick: onClick,
        responsive: true,
        size: size,
        to: routerPath,
        truncate: false,
        type: "button",
        use: use,
        children: buttonText
      })
    });
  }
  return /*#__PURE__*/_jsx(Button, {
    external: true,
    href: buttonUrl,
    onClick: onClick,
    size: size,
    use: use,
    children: buttonText
  });
}